import styled from "styled-components";
import useGlobalSettings from "../Provider/useGlobalSettings";
import { Styles } from "../Styles/Styles";
import {Colors} from "../Styles/Colors";
import {useMemo} from "react";
import useWebSocketServer from "../Provider/useWebSocketServer";

const _Styles = {
    InputRow: styled.div`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        padding-top: 20px;
        padding-left: 10px;
        padding-right: 10px;
        width: 100%;
    `,
    Label: styled.span`
        min-width: min( 150px, 80% );
        text-align: left;
        font-size: smaller;
    `,
    UUID: styled.span`
        font-weight: bold;
        border-bottom: 1px solid ${ Colors.schemas.secondary };
        font-size: large;
        @media (max-width: 500px) {
            width: calc( 100% - 20px );
            flex-wrap: wrap;
        }
    `,
    UUID_Button: styled(Styles.Input.button.secondary)`
        margin-left: auto;
        margin-right: 20px;
    `,
    UserName: styled.input`
        font-weight: bold;
        border: none;
        border-bottom: 1px solid ${ Colors.schemas.secondary };
        font-size: large;
        background-color: transparent;
        color: inherit;
        @media (max-width: 500px) {
            width: calc( 100% - 20px );
            flex-wrap: wrap;
        }
    `,
}

const ActionButtonUserUUID = () => {

    const { user, Actions } = useGlobalSettings()

    const handles = {
        reset: Actions.profile.reset,
        generateUUID: Actions.profile.generateUUID
    }

    return user.uuid
        ? <_Styles.UUID_Button onClick={ handles.reset }>Werkseinstellung</_Styles.UUID_Button>
        : <_Styles.UUID_Button onClick={ handles.generateUUID }>Neu Initialisieren</_Styles.UUID_Button>
}

export const Profile = () => {

    const { user, activeMission, Actions } = useGlobalSettings()
    const { connected } = useWebSocketServer()

    const handles = {
        deleteActiveMission: () => Actions.ActiveMission.delete()
    }

    const status = useMemo( () => {
        if( ! ( connected && user?.name && user.uuid ) )
            return 'offline'

        if( user.data.GameMasterFor && activeMission )
            return '!! GameMaster !!'

        return 'aktiv und verbunden'

    }, [ connected, user, activeMission ])

    return <div style={{ width: '100vw', overflowX: 'hidden' }}>
        <_Styles.InputRow>
            <_Styles.Label>Kennung:</_Styles.Label>
            <_Styles.UUID>{ user.uuid?.toUpperCase() ?? 'nicht initialisiert !!!' }</_Styles.UUID>
            <ActionButtonUserUUID />
        </_Styles.InputRow>
        <_Styles.InputRow>
            <_Styles.Label>Rufzeichen:</_Styles.Label>
            <_Styles.UserName type={'text'} value={ user.name ?? 'Gast' }
                              onChange={ (e) => Actions.profile.setName( e.target.value ) } />
        </_Styles.InputRow>
        <_Styles.InputRow>
            <_Styles.Label>Status:</_Styles.Label>
            <_Styles.UUID>{ status }</_Styles.UUID>
            { user.data.GameMasterFor && activeMission && <_Styles.UUID_Button onClick={ handles.deleteActiveMission }>Löschen</_Styles.UUID_Button> }
        </_Styles.InputRow>
        <_Styles.InputRow>
            <_Styles.Label>Mission:</_Styles.Label>
            <_Styles.UUID>{ activeMission?.toUpperCase() ?? 'keine aktive Mission' }</_Styles.UUID>
            <_Styles.UUID_Button disabled={ ! activeMission } onClick={ handles.deleteActiveMission }>Löschen</_Styles.UUID_Button>
        </_Styles.InputRow>
    </div>
}